// extracted by mini-css-extract-plugin
export var blink = "animateImage-module--blink--58e77";
export var blink2 = "animateImage-module--blink2--6e696";
export var container = "animateImage-module--container--2402f";
export var normal = "animateImage-module--normal--d2663";
export var normal1 = "animateImage-module--normal1--54122";
export var normal2 = "animateImage-module--normal2--531b1";
export var start = "animateImage-module--start--eb9b3";